import { ListParams } from '../../Components/List/hooks'
import { Filter } from '../../Components/Filters/types'

export type USER_STATE = {
  readonly dateStart: Date | null
  readonly dateEnd: Date | null
  readonly websites: ReadonlyArray<string>
  readonly type: ReadonlyArray<string>
  readonly moderation: ReadonlyArray<string>
} & ListParams

export const USER_TABS = [
  {label: 'All Users', value: 'all'},
  {label: 'Pending', value: 'pending'},
  {label: 'Active', value: 'active'},
  {label: 'Banned', value: 'blocked'},
]

export const INIT_USER_STATE: USER_STATE = {
  page: 1,
  tab: USER_TABS[0].value,
  searchTerm: '',
  sort: null,
  websites: [],
  type: [],
  moderation: [],
  dateStart: null,
  dateEnd: null,
}

export const USER_FILTERS: ReadonlyArray<Filter<USER_STATE>> = [
  {
    displayName: 'Sort By',
    fieldName: 'sort',
    type: 'radio',
    options: [
      // { name: 'New to old', value: { sortBy: 'created', order: 'DESC' } },
      // { name: 'Old to new', value: { sortBy: 'created', order: 'ASC' } },
      { name: 'Username, A-Z', value: { sortBy: 'name', order: 'ASC' } },
      { name: 'Username, Z-A', value: { sortBy: 'name', order: 'DESC' } },
      // { name: 'Most comments', value: { sortBy: 'count', order: 'DESC' } },
      // { name: 'Least comments', value: { sortBy: 'count', order: 'ASC' } },
      // { name: 'Most flagged', value: { sortBy: 'flagged', order: 'DESC' } },
      // { name: 'Least flagged', value: { sortBy: 'flagged', order: 'ASC' } },
    ],
  },
  {
    displayName: 'Date',
    type: 'daterange',
    startFieldName: 'dateStart',
    endFieldName: 'dateEnd',
  },
  {
    displayName: 'User type',
    fieldName: 'type',
    type: 'checkbox',
    options: [
      { name: 'Users', value: 'user' },
      // { name: 'Moderators', value: 'mods' },
      { name: 'Admins', value: 'admin' },
    ],
  },
]
